import { useState } from 'react';
import { Plus, X } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface Props {
  data: { id: number; name: string }[];
  maxLength?: number;
}

export default function ShowHideDisplay({ data, maxLength = 3 }: Props) {
  const [expanded, setExpanded] = useState(false);
  const remainingCount = data.length - maxLength;
  const truncatedData = data.slice(0, maxLength);

  return (
    <span className="flex flex-wrap items-center gap-1.5">
      {expanded ? (
        <>
          {data.map((item, index) => (
            <span key={item.id} className="whitespace-break-spaces">
              {item.name}
              {index < data.length - 1 ? ', ' : ''}
            </span>
          ))}
          <Button
            className="h-7"
            data-testid="close-icon"
            onClick={(event) => {
              event.stopPropagation();
              setExpanded(false);
            }}
            size="sm"
            variant="outline"
          >
            <X className="size-3" />
          </Button>
        </>
      ) : (
        <span className="flex flex-wrap items-center gap-1.5">
          {truncatedData.map((item, index) => (
            <span key={item.id} className="whitespace-break-spaces">
              {item.name}
              {index < truncatedData.length - 1 ? ', ' : ''}
            </span>
          ))}
          {remainingCount > 0 && (
            <Button
              className="h-7 gap-1 text-xs"
              data-testid="expand-icon"
              onClick={(event) => {
                event.stopPropagation();
                setExpanded(true);
              }}
              size="sm"
              variant="outline"
            >
              <Plus className="size-3" />
              {remainingCount}
            </Button>
          )}
        </span>
      )}
    </span>
  );
}
